import React from "react";
import AutoAwesome from '@mui/icons-material/AutoAwesome'
import HomeOutlined from '@mui/icons-material/HomeOutlined'
import History from '@mui/icons-material/History'
import Close from '@mui/icons-material/Close'
import Add from '@mui/icons-material/Add'
import Search from '@mui/icons-material/Search'
import OpenInFull from '@mui/icons-material/OpenInFull'
import CloseFullscreen from '@mui/icons-material/CloseFullscreen'
import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'
import ChevronRight from '@mui/icons-material/ChevronRight'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ExpandLess from '@mui/icons-material/ExpandLess'
import LightbulbOutlined from '@mui/icons-material/LightbulbOutlined'
import MapOutlined from '@mui/icons-material/MapOutlined'
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined'
import MenuBookOutlined from '@mui/icons-material/MenuBookOutlined'
import LayersOutlined from '@mui/icons-material/LayersOutlined'
import PlaceOutlined from '@mui/icons-material/PlaceOutlined'
import PentagonOutlined from '@mui/icons-material/PentagonOutlined'
import WarningAmberRounded from '@mui/icons-material/WarningAmberRounded'
import ThumbUpOutlined from '@mui/icons-material/ThumbUpOutlined'
import ThumbDownOutlined from '@mui/icons-material/ThumbDownOutlined'
import ContentCopy from '@mui/icons-material/ContentCopy'
import FlagOutlined from '@mui/icons-material/FlagOutlined'
import StopRounded from '@mui/icons-material/StopRounded'
import VisibilityOutlined from '@mui/icons-material/VisibilityOutlined'
import LockOutlined from '@mui/icons-material/LockOutlined'
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline'
import CalendarMonthOutlined from '@mui/icons-material/CalendarMonthOutlined'
import DeleteOutline from '@mui/icons-material/DeleteOutline'
import OpenInNew from '@mui/icons-material/OpenInNew'
import BarChart from '@mui/icons-material/BarChart'
import Terrain from '@mui/icons-material/Terrain'
import AutoStoriesOutlined from '@mui/icons-material/AutoStoriesOutlined'
import MicNoneOutlined from '@mui/icons-material/MicNoneOutlined'
import EditOutlined from '@mui/icons-material/EditOutlined'
import NavigationOutlined from '@mui/icons-material/NavigationOutlined'
import WbSunnyOutlined from '@mui/icons-material/WbSunnyOutlined'
import NightlightOutlined from '@mui/icons-material/NightlightOutlined'
import Mic from '@mui/icons-material/Mic'
import VolumeUpOutlined from '@mui/icons-material/VolumeUpOutlined'
import VolumeOffOutlined from '@mui/icons-material/VolumeOffOutlined'
import MoreHoriz from '@mui/icons-material/MoreHoriz'
import IosShare from '@mui/icons-material/IosShare'
import PeopleOutline from '@mui/icons-material/PeopleOutline'
import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined'
import LogoutOutlined from '@mui/icons-material/LogoutOutlined'
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined'
import SettingsOutlined from '@mui/icons-material/SettingsOutlined'
import SwapHoriz from '@mui/icons-material/SwapHoriz'
import LocalFireDepartmentOutlined from '@mui/icons-material/LocalFireDepartmentOutlined'
import MailOutline from '@mui/icons-material/MailOutline'

// The Artemis panel's icons, by the names the design uses. Decorative unless a label is given.
const ICONS = {
  sparkle: AutoAwesome,
  home: HomeOutlined,
  history: History,
  close: Close,
  plus: Add,
  find: Search,
  expand: OpenInFull,
  collapse: CloseFullscreen,
  back: ArrowBack,
  send: ArrowForward,
  chevronRight: ChevronRight,
  chevronDown: ExpandMore,
  chevronUp: ExpandLess,
  think: LightbulbOutlined,
  map: MapOutlined,
  reg: DescriptionOutlined,
  search: MenuBookOutlined,
  layer: LayersOutlined,
  pin: PlaceOutlined,
  shape: PentagonOutlined,
  failed: WarningAmberRounded,
  thumbUp: ThumbUpOutlined,
  thumbDown: ThumbDownOutlined,
  copy: ContentCopy,
  flag: FlagOutlined,
  stop: StopRounded,
  eye: VisibilityOutlined,
  lock: LockOutlined,
  chat: ChatBubbleOutline,
  calendar: CalendarMonthOutlined,
  trash: DeleteOutline,
  external: OpenInNew,
  chart: BarChart,
  terrain: Terrain,
  skill: AutoStoriesOutlined,
  mic: MicNoneOutlined,
  edit: EditOutlined,
  arrow: NavigationOutlined,
  sun: WbSunnyOutlined,
  moon: NightlightOutlined,
  micOn: Mic,
  speaker: VolumeUpOutlined,
  speakerOff: VolumeOffOutlined,
  more: MoreHoriz,
  share: IosShare,
  people: PeopleOutline,
  archive: ArchiveOutlined,
  leave: LogoutOutlined,
  bell: NotificationsNoneOutlined,
  settings: SettingsOutlined,
  swap: SwapHoriz,
  fire: LocalFireDepartmentOutlined,
  mail: MailOutline
}

const Icon = ({ name, size = 16 }) => {
  const Component = ICONS[name] || AutoAwesome
  return <Component aria-hidden="true" focusable="false" style={{ fontSize: size }} />
}

export default Icon
